__turbopack_context__.v({
  "breakage-warning": "tracker-report-module-scss-module__v93mBW__breakage-warning",
  "confidentiality-notice": "tracker-report-module-scss-module__v93mBW__confidentiality-notice",
  "count": "tracker-report-module-scss-module__v93mBW__count",
  "entries": "tracker-report-module-scss-module__v93mBW__entries",
  "explainer": "tracker-report-module-scss-module__v93mBW__explainer",
  "fadein": "tracker-report-module-scss-module__v93mBW__fadein",
  "faq": "tracker-report-module-scss-module__v93mBW__faq",
  "faq-wrapper": "tracker-report-module-scss-module__v93mBW__faq-wrapper",
  "from": "tracker-report-module-scss-module__v93mBW__from",
  "headline": "tracker-report-module-scss-module__v93mBW__headline",
  "icon": "tracker-report-module-scss-module__v93mBW__icon",
  "lead": "tracker-report-module-scss-module__v93mBW__lead",
  "load-error": "tracker-report-module-scss-module__v93mBW__load-error",
  "loading": "tracker-report-module-scss-module__v93mBW__loading",
  "logo": "tracker-report-module-scss-module__v93mBW__logo",
  "logomark": "tracker-report-module-scss-module__v93mBW__logomark",
  "logotype": "tracker-report-module-scss-module__v93mBW__logotype",
  "meta": "tracker-report-module-scss-module__v93mBW__meta",
  "read-more": "tracker-report-module-scss-module__v93mBW__read-more",
  "report": "tracker-report-module-scss-module__v93mBW__report",
  "report-wrapper": "tracker-report-module-scss-module__v93mBW__report-wrapper",
  "tracker-domain": "tracker-report-module-scss-module__v93mBW__tracker-domain",
  "trackers": "tracker-report-module-scss-module__v93mBW__trackers",
  "wrapper": "tracker-report-module-scss-module__v93mBW__wrapper",
});
